<div class="box ml-2">
  <div class="box-header">


  </div>

  <!-- add user -->
  <div class="flex-align-center py-2 px-3">
    @if (userAction==='store-user-add') {
      <span class="font-weight-bold title-lg">{{'Add User' | translate}}</span>
    }

    @if (userAction==='store-user-edit') {
      <span class="font-weight-bold title-lg">{{'Edit User' | translate}}</span>
    }
    @if (userAction==='profile') {
      <span class="font-weight-bold title-lg">{{'My Profile' | translate}}</span>
    }

    @if (userAction!=='profile') {
      <button mat-stroked-button (click)="backToSummary()" class="ml-auto">
        <mat-icon>groups</mat-icon>
        {{'Back to User List' | translate}}
      </button>
    }
    @if (userAction==='profile') {
      <button mat-stroked-button (click)="exitProfile()" class="ml-auto">
        <mat-icon>groups</mat-icon>
        {{'Exit Profile' | translate}}
      </button>
    }
  </div>
  <div class="box-body">
    <form [formGroup]="storeUserForm">
      <div class="col form col-md-8">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'First Name' | translate}}</mat-label>
              <input matInput maxlength="50" specialCharctersRestrict formControlName="firstName" required [errorStateMatcher]="nameErrorMatcher" />
              <mat-error>
                @if (storeUserForm.get('firstName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'Last Name' | translate}}</mat-label>
              <input maxlength="50" specialCharctersRestrict formControlName="lastName" matInput required [errorStateMatcher]="nameErrorMatcher" />
              <mat-error>
                @if (storeUserForm.get('lastName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{'Initials (optional)' | translate}}</mat-label>
              <input matInput maxlength="50" specialCharactersRestrictAllowEmpty formControlName="intials" [errorStateMatcher]="nameErrorMatcher" />
              <mat-error>
                @if (storeUserForm.get('intials').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Licence #' | translate}}</mat-label>
              <input matInput maxlength="50" required appUserLicense formControlName="license" />
              <mat-error>
                @if (storeUserForm.get('license').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'User ID' | translate}}</mat-label>
              <input matInput required maxlength="100" emailRestrict formControlName="upn" />
              <mat-error>
                @if (storeUserForm.get('upn').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">



            @if (userAction!=='store-user-add') {
              <mat-form-field appearance="outline">
                <mat-label>{{'Store Location' | translate}}</mat-label>
                <mat-select required  formControlName="storeNumber" (selectionChange)="getESAByStore($event)" >
                  @for (store of storeNumbers; track store) {
                    <mat-option [value]="store.storeNumber">{{store.banner}}-{{store.sdmStoreNumber}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            @if (userAction==='store-user-add') {
              <mat-form-field appearance="outline" >
                <mat-label>{{'Store Location' | translate}}</mat-label>
                <mat-select #mySel multiple required  formControlName="storeNumber">
                  <input #search placeholder="{{'Search' | translate}}" [formControl]="searchTextboxControl" matInput type="text"   class="search-input">
                  <button mat-icon-button  matTooltip="{{'Select All' | translate}}" (click)="toggleAllSelection()">
                    <mat-icon>done_all</mat-icon>
                  </button>
                  <button mat-icon-button  matTooltip="{{'Unselect All' | translate}}" (click)="toggleAllDeSelection()">
                    <mat-icon>undo</mat-icon>
                  </button>
                  <!-- <mat-option  [value]="0" (click)="toggleAllSelection()">ALL</mat-option> -->
                  @for (store of filteredOptions | async; track store) {
                    <mat-option (onSelectionChange)="selectionChange($event)"  [value]="store.storeNumber">{{store.banner}}-{{store.sdmStoreNumber}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }


          </div>

        </div>
        <div class="row">
          <div class="col">


            <div>
              {{'Language' | translate}} *
              <div class="my-2">
                <mat-radio-group formControlName="language">
                  <mat-radio-button value="EN">{{'English' | translate}}</mat-radio-button>
                  <mat-radio-button value="FR" class="mx-2">{{'French' | translate}}</mat-radio-button>
                </mat-radio-group>

              </div>
            </div>

          </div>
          <!-- space -->
          <div class="col hide-sm"></div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'User Role' | translate}}</mat-label>
              <mat-select required formControlName="roleId" disableOptionCentering>
                @for (role of userRoles; track role) {
                  <mat-option [value]="role.roleIdAccess">
                    {{ role.roleName | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- <mat-form-field appearance="outline" *ngIf="userAction==='profile'">
            <mat-label>{{'User Role' | translate}}</mat-label>
            <mat-select required formControlName="roleId" disableOptionCentering>
              <mat-option [value]="userData.usersRole.roleId">
                {{ userData.usersRole.roleName | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>
      </div>
      <div class="row">
        <div class="col col-md-4">
          <div class="mb-2">{{'Accepted Electronic Signature Attestation' | translate}}</div>
          <!-- <mat-form-field appearance="outline" *ngIf="userAction!=='profile'">
          <mat-label>Choose a date</mat-label>
          <input matInput formControlName="usa" [matDatepicker]="picker1" />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field> -->
        <mat-form-field appearance="outline">
          <mat-label>{{'esaDateFormat' | translate}}</mat-label>
          <input matInput [disabled]="true"
            [value]="storeUserForm.get('esa').value | date : dateTimeFormat : '' : 'fr'"
            formControlName="esa" placeholder="YYYY-MM-DD HH:MM:SS" matInput />
        </mat-form-field>
      </div>
    </div>
    <div class="row form-group flex-align-center">
      @if (userAction!=='profile') {
        <div class="col">
          <mat-label>{{'User Status' | translate}}</mat-label>
          <div class="my-2">
            <mat-slide-toggle formControlName="userStatus" class="example-margin" (change)="setUserStatus($event)">
              {{statusString | translate}}
            </mat-slide-toggle>
          </div>
        </div>
      }
      <div class="col text-right">
        <button mat-raised-button color="primary" [disabled]="!storeUserForm.valid" (click)="saveUser()">{{'Save' | translate}}</button>
      </div>
    </div>
  </div>
</form>
</div>
</div>
